import template from './noteAdd.template.html';

export default {
  template,
  bindings: {
    ticket: '=',
    contact: '<',
    labels: '<',
    onCancelled: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdMedia,
      uiService,
      fileFactory,
      noteService,
      Note,
      NOTE,
      NoteAttribute,
      Document
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentAccount = null;
      ctrl.mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentAccount = $rootScope.CurrentAccount;
        ctrl.note = Note.blank();
        ctrl.files = [];
        ctrl.url = NOTE.API.UPLOAD;
        ctrl.idContact = ctrl.contact ? ctrl.contact.id : '';
        ctrl.idTicket = ctrl.ticket ? ctrl.ticket.id : '';
        ctrl.idWorkflow = ctrl.ticket ? ctrl.ticket.idWorkflow : '';
        ctrl.title = 'Drag & Drop file(s) here, or click to browse';
        ctrl.allowedMimeTypes = '';
        ctrl.allowedExtensions = '';
        ctrl.startUpload = false;
        ctrl.startSaveProcess = false;
      };
      ctrl.notePinned = () => {
        ctrl.note.isPinned = !ctrl.note.isPinned;
      };
      ctrl.attributeAdd = () => {
        ctrl.note.attributes.push(NoteAttribute.blank());
      };
      ctrl.attributeDelete = (index) => {
        ctrl.note.attributes.splice(index, 1);
      };
      ctrl.noteShared = () => {
        ctrl.note.isShared = !ctrl.note.isShared;
      };
      ctrl.noteSharedPartner = () => {
        ctrl.note.isSharedPartner = !ctrl.note.isSharedPartner;
      };
      ctrl.noteLabelsSelected = (selectedLabels) => {
        ctrl.note.idLabels = selectedLabels;
      };
      ctrl.uploadFinished = (files) => {
        ctrl.startUpload = false;
        ctrl.startSaveProcess = true;
        ctrl.save({
          note: ctrl.note,
          attachments: files,
          idTicket: ctrl.idTicket,
          idWorkflow: ctrl.idWorkflow,
          idContact: ctrl.idContact
        });
      };
      ctrl.confirm = (note) => {
        if (note.content !== '') {
          if (
            ctrl.noteAdd.files &&
            ctrl.noteAdd.files.$viewValue &&
            ctrl.noteAdd.files.$viewValue.length
          ) {
            ctrl.startUpload = true;
            ctrl.files = ctrl.noteAdd.files.$viewValue;
          } else {
            ctrl.startSaveProcess = true;
            ctrl.save({
              note,
              attachments: [],
              idTicket: ctrl.idTicket,
              idWorkflow: ctrl.idWorkflow,
              idContact: ctrl.idContact
            });
          }
        } else {
          uiService.toast({
            text: {
              p1: 'Note',
              p2: 'content',
              p3: 'is required'
            },
            warn: true
          });
        }
      };
      ctrl.cancel = () => {
        ctrl.startSaveProcess = true;
        ctrl.onCancelled();
        $timeout(() => {
          ctrl.initialize();
        });
      };
      ctrl.save = (res) => {
        const result = res;
        for (let a = 0; a < result.attachments.length; a += 1) {
          const attachment = Document.blank();
          attachment.idOwner = ctrl.currentAccount.id;
          attachment.name = result.attachments[a].name;
          attachment.file = result.attachments[a].file;
          attachment.isShared = !!result.note.isShared;
          attachment.isSharedPartner = !!result.note.isSharedPartner;
          result.note.attachments.push(attachment);
        }
        result.note.idContact = result.idContact;
        result.note.idTicket = result.idTicket;
        result.note.idWorkflow = result.idWorkflow;
        result.note.type = 'comment';
        result.note.content = result.note.content.cleanHtml();
        noteService.createNote(result.note).then((data) => {
          if (data.status) {
            result.note.id = data.id;
            result.note.idOwner = ctrl.currentAccount.id;
            result.note.isNew = true;
            ctrl.cancel();
            ctrl.onFinished({ note: result.note });
            uiService.toast({
              text: {
                p1: 'Note',
                p2: result.note.getExcerpt(),
                p3: 'has been added'
              }
            });
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
